import { Link, useLocation } from 'react-router-dom';
import { HiSearch, HiShoppingBag, HiHome } from 'react-icons/hi';
import '../styles/NotFound.css';

/*
  Catch-all for an address that doesn't exist.

  Vercel rewrites every unknown path to index.html so the router can
  handle it (see vercel.json). Without a route matching "*", those
  paths rendered the site chrome wrapped around a blank white middle,
  which reads as a broken site rather than a wrong address.
*/
export default function NotFound() {
  const { pathname } = useLocation();

  return (
    <section className="notfound">
      <span className="notfound-code">404</span>
      <h1>This page has drifted out of orbit</h1>

      <p>
        We couldn't find <code>{pathname}</code>. It may have moved, or the
        link that brought you here may be out of date.
      </p>

      <div className="notfound-actions">
        <Link className="notfound-btn" to="/shop">
          <HiShoppingBag />
          <span>Browse the collection</span>
        </Link>
        <Link className="notfound-btn is-ghost" to="/">
          <HiHome />
          <span>Back to home</span>
        </Link>
      </div>

      <div className="notfound-links">
        <span>
          <HiSearch /> Looking for something in particular?
        </span>
        <ul>
          <li>
            <Link to="/shop">All gemstones</Link>
          </li>
          <li>
            <Link to="/planets">Shop by planet</Link>
          </li>
          <li>
            <Link to="/blog">Journal</Link>
          </li>
          <li>
            <Link to="/shipping-returns">Shipping &amp; returns</Link>
          </li>
          <li>
            <Link to="/account">My account</Link>
          </li>
        </ul>
      </div>
    </section>
  );
}
